import styled from 'styled-components';

// Styles for datapicker customization
export const CustomDatepickerContainer = styled.div``;
